var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileTwitterLogo = function SvgMobileTwitterLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#55ACEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#5F787E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.631 6 4.95 6.619L5.6 18h1.121l4.361-4.711L14.606 18h3.815l-5.228-6.99L17.829 6h-1.121l-4.016 4.34L9.446 6H5.631Zm1.649.826h1.753l7.74 10.348H15.02L7.28 6.826Z",
    fill: "#fff"
  })));
};
export default SvgMobileTwitterLogo;